export const environment = {
  production: true,
  environment: 'QA',
  version: '1.1.23',
  commitSha: '57e52c9b',
  UpsApiEndpoint: 'https://upservice-web-qa.azurewebsites.net/',
  EliotApiEndpoint: 'https://upservice-web-qa.azurewebsites.net/',
  eliot_ocp_key: 'ac9f9c0ffcb94e959062160efb6058ac',
  ups_ocp_key: '378d45106b0743b49d3e88c8193c151a',
  profileWebviewUrl: 'https://beta.myconnectedaccount.legrand.com/',
  firebaseConfig: {
    apiKey: "AIzaSyAF9aggxa0Uef41bk0FEruEAKPhdlgRz-k",
    authDomain: "upservice-legrand.firebaseapp.com",
    projectId: "upservice-legrand",
    storageBucket: "upservice-legrand.firebasestorage.app",
    messagingSenderId: "548145135865",
    appId: "1:548145135865:web:3794bbbf643f195226e228",
    measurementId: "G-VY77BK72NM"
  },
  codeAuth: {
    clientId: '6a1787a0-87f9-4255-97bb-82bc7e552def',
    responseType: 'code',
    redirectUri: 'https://upservice-web-qa.azurewebsites.net/login',
    loginUrl:
      'https://qa.login.eliotbylegrand.com/8f765e3b-545c-45e1-a3b8-f0fc0599b42d/oauth2/v2.0/authorize?p=B2C_1A_UpServiceWeb',
    clientSecret: 'jpPDU2j_RlFM3-hg~2je7e0xf489-q_bYh',
    timeoutFactor: 300000,
    scope:
      'openid offline_access https://EliotClouduamqa.onmicrosoft.com/security/access.full',
  },
  tokenAuth: {
    clientId: '6a1787a0-87f9-4255-97bb-82bc7e552def',
    responseType: 'token',
    tokenEndpoint:
      'https://qa.login.eliotbylegrand.com/8f765e3b-545c-45e1-a3b8-f0fc0599b42d/oauth2/v2.0/token?p=B2C_1A_UpServiceWeb',
    grantType: 'authorization_code',
    clientSecret: 'jpPDU2j_RlFM3-hg~2je7e0xf489-q_bYh',
  },
  logOutUrl:
    'https://qa.login.eliotbylegrand.com/8f765e3b-545c-45e1-a3b8-f0fc0599b42d/oauth2/v2.0/logout?p=B2C_1A_UpServiceWeb',
  logoutRedirectUri: 'https://upservice-web-qa.azurewebsites.net/prelogin',
  storage: {
    accessToken: 'UPService-access-token',
    sasToken: 'UPService-sas-token',
    idToken: 'UPService-id-token',
    refreshToken: 'UPService-refresh-token',
    tokenExpiresIn: 'UPService-expires-in',
    eliotUser: 'UPS-EliotUser',
    searchHistory: 'UPService-search-history',
    upsUser: 'UPS-UpsUser',
    upsBackofficeLanguages: 'UPService-backoffice-languages',
    upsSelectedDocument: 'UPService-selected-document',
    settingsDateFormat: 'UPService-date-format',
    articleCodes: 'UPService-article-codes',
    selectedArticleCode: 'UPService-selected-article-code',
    agenda: 'UPService-agenda',
    news: 'UPService-news',
  },
};
